var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fab-btn",on:{"click":() => _vm.$emit('click')}},[_c('div',{staticClass:"fab-btn-text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }